import React from "react";
import { Subscribe } from "unstated";
import PlayerContainer from "../state";
//import { notes, octaves } from "../ragas";

export class KaalamSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false };
        this.getDropDownStyle = this.getDropDownStyle.bind(this);
        this.toggleExpanded= this.toggleExpanded.bind(this);
        this.getKaalamText = this.getKaalamText.bind(this);
    }

    getDropDownStyle() {
        if (!this.state.expanded) return "dropdown kaalam-selector";
        else return "dropdown kaalam-selector is-active";
    }

    toggleExpanded() {
        this.setState({ expanded: !this.state.expanded});
    }

    getKaalamText(k) {
        if(k===2) {
            return 1;
        }
        else if(k===1) {
            return 2;
        }
        return 3;
    }
    render() {
        return (
            <Subscribe to={[PlayerContainer]}>
                {playerContainer => {
                    return (
                        <div>
                            <div className={this.getDropDownStyle()}>
                                <div className="dropdown-trigger" onClick={this.toggleExpanded}>
                                    <button className="button" aria-haspopup="true" aria-controls="dropdown">
                                        <span className="kaalam">
                                            {this.getKaalamText(playerContainer.state.kaalam)}
                                        </span>
                                        <span className="icon is-small">
                                            <i className="fas fa-angle-down" aria-hidden="false"></i>
                                        </span>
                                    </button>
                                </div>
                                <div className="dropdown-menu" role="menu">
                                    <div className="dropdown-content">
                                        {[2,1,0.5].map((kaalam) => (
                                            <a href="#" className="dropdown-item" onClick={() => {
                                                playerContainer.setKaalam(kaalam);
                                                this.toggleExpanded();
                                            }}>
                                                {this.getKaalamText(kaalam)}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            
                            </div>
                    );
                }}
            </Subscribe>
        );
    }
}
